var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.361 23.783H4.553a1.155 1.155 0 01-1.154-1.153v-8.591H1.177a1.155 1.155 0 01-1.154-1.154v-3.68c0-.637.518-1.155 1.154-1.155h2.222V6.207c0-1.828.574-3.383 1.66-4.497C6.149.591 7.673 0 9.466 0l2.904.005a1.155 1.155 0 011.152 1.153v3.418c0 .636-.517 1.154-1.153 1.154h-1.956c-.596 0-.748.12-.78.157-.054.06-.118.232-.118.707V8.05h2.707a1.158 1.158 0 011.164 1.154l-.001 3.681c0 .636-.518 1.154-1.154 1.154H9.515v8.59c0 .637-.518 1.154-1.154 1.154zM4.793 22.39h3.328v-8.974c0-.425.345-.77.77-.77h3.1v-3.2h-3.1a.771.771 0 01-.77-.77V6.593c0-.545.055-1.164.466-1.63.497-.563 1.28-.628 1.826-.628h1.715V1.399l-2.663-.005c-2.881 0-4.672 1.845-4.672 4.813v2.467c0 .425-.345.77-.77.77H1.418v3.2h2.605c.425 0 .77.346.77.77v8.975z","fill":"#44474F","fillRule":"nonzero"}));
}

Facebook.defaultProps = {"viewBox":"0 0 14 24"};

module.exports = Facebook;

Facebook.default = Facebook;
